export default {"src":"/_next/static/media/trending-down.9b846b2b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};